import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IncidentFormControls, VideoSnapshot } from '../../../../../types';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-review-form-recent-walk-ins',
  templateUrl: './review-form-recent-walk-ins.component.html',
  styleUrl: './review-form-recent-walk-ins.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormRecentWalkInsComponent {
  public form = input.required<FormGroup<IncidentFormControls>>();
  public snapshots = input<VideoSnapshot[]>([]);
  public locationTimezone = input<string | undefined>();

  public walkInTimestampLabel(value: VideoSnapshot['image_timestamp']): string {
    const dt = this.locationTimezone()
      ? DateTime.fromMillis(value, { zone: 'utc' }).setZone(this.locationTimezone())
      : DateTime.fromMillis(value);

    if (!dt.isValid) return '';
    return dt.toFormat('MM/dd/yyyy hh:mm:ss a');
  }

  public isSelected(link: string): boolean {
    return this.form().controls.selectedImages.value.includes(link);
  }

  public toggleSelection(snapshot: VideoSnapshot) {
    const link = snapshot.link;
    const selected = this.form().controls.selectedImages;
    const idx = selected.value.findIndex((l) => l === link);
    if (idx >= 0) {
      selected.removeAt(idx);
    } else {
      selected.push(new FormControl(link, { nonNullable: true }));
      // selecting any image implies the person returned
      this.form().controls.didNotReturn.setValue(false);
    }
    this.form().updateValueAndValidity();
  }

  public clearSelection() {
    this.form().controls.selectedImages.clear();
    this.form().updateValueAndValidity();
  }
}
